/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupcreatehint2Inputs */

const en_signupcreatehint2 = /** @type {(inputs: Signupcreatehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You set questions, seats and the deadline on the event page once it is created.`)
};

const de_signupcreatehint2 = /** @type {(inputs: Signupcreatehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen, Plätze und Anmeldeschluss stellst du nach dem Erstellen auf der Eventseite ein.`)
};

/**
* | output |
* | --- |
* | "You set questions, seats and the deadline on the event page once it is created." |
*
* @param {Signupcreatehint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupcreatehint2 = /** @type {((inputs?: Signupcreatehint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupcreatehint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupcreatehint2(inputs)
	return de_signupcreatehint2(inputs)
});
export { signupcreatehint2 as "signupCreateHint" }